import { FormHelperText, Grid } from "@mui/material";
import type { ChangeEvent, ClipboardEvent, KeyboardEvent } from "react";

import { StyledTextField } from "../styled-text-field";

interface PasswordResetInputTemplateProps {
	readonly verificationCode: string[];
	readonly inputRefs: React.MutableRefObject<(HTMLInputElement | null)[]>;
	readonly onChange: (index: number, e: ChangeEvent<HTMLInputElement>) => void;
	readonly onKeyDown: (index: number, e: KeyboardEvent<HTMLInputElement>) => void;
	readonly onPaste: (e: ClipboardEvent<HTMLInputElement>) => void;
	readonly error?: boolean;
	readonly helperText?: string;
}

export const PasswordResetInputTemplate: React.FC<PasswordResetInputTemplateProps> = ({
	verificationCode,
	inputRefs,
	onChange,
	onKeyDown,
	onPaste,
	error,
	helperText,
}) => {
	const positions = Array.from({ length: verificationCode.length }, (_, i) => i);

	return (
		<Grid container direction="column" gap={0.5}>
			<Grid id="code-inputs" container gap={1.5} justifyContent="center">
				{positions.map((position) => (
					<StyledTextField
						autoFocus={position === 0}
						variant="outlined"
						key={`code-input-${position}`}
						id={`code-input-${position}`}
						data-testid={`password-reset-input__input__code-${position}`}
						value={verificationCode[position]}
						type="text"
						inputMode="text"
						error={error}
						inputRef={(el) => (inputRefs.current[position] = el)}
						onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(position, e)}
						onKeyDown={(e: KeyboardEvent<HTMLInputElement>) => onKeyDown(position, e)}
						onPaste={onPaste}
						inputProps={{
							maxLength: 1,
						}}
						sx={{
							width: 48,
							"& .MuiOutlinedInput-root": {
								borderRadius: 2,
							},
							"& input": {
								textAlign: "center",
								fontSize: (theme) => theme.typography.h5.fontSize,
								fontWeight: (theme) => theme.typography.h5.fontWeight,
								padding: "12px 0",
							},
						}}
					/>
				))}
			</Grid>

			{Boolean(helperText) === true && (
				<FormHelperText error={error} sx={{ textAlign: "center" }} data-testid="password-reset-input__text__helper">
					{helperText}
				</FormHelperText>
			)}
		</Grid>
	);
};
